<template>
  <v-row>
    <v-col
      :key="index"
      v-for="(stat, index) in stats"
    >
      <v-card>
        <v-card-text>
          <h3><span class="primary--text">{{stat.title}}<br></span> {{stat.count}}</h3>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Stats',
    props: {
      stats: { kind: Array, default: () => [] }
    }
  }
</script>

<style>
</style>